import React, { useState } from "react";
import Axios from "axios";
import OnCall from "./Dialpad/OnCall";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ContactCard from "./Grid/ContactCard";

const Recent = (props) => {
  const contactlist = props.recentcontacts;
  const [callStatus, setCallStatus] = useState({});
  const [dialContactName, setDialContactName] = useState("");
  const [dialContactNumber, setDialContactNumber] = useState("");
  const [ringaction, setRingAction] = useState("Hung Up");
  const [Message, setMessage] = useState("");

  const [showElement, setShowElement] = React.useState(true);

  const [apiData, setapiData] = useState({
    apiurl: process.env.REACT_APP_BACKEND_API_URL,
    apitoken: process.env.REACT_APP_BACKEND_API_TOKEN,
  });

  const handleDialClick = async (contactname, phone) => {
    setDialContactName(contactname);
    setDialContactNumber(phone);
    const params = JSON.stringify({
      action: "dialeraction",
      method: "dial",
      emailaddress: props.accountemail,
      contact: phone,
    });
    const headerconfig = {
      headers: {
        "Content-Type": "application/json",
        authorization: apiData.apitoken!,
      },
    };
    const result = await Axios.post(apiData.apiurl!, params, headerconfig);
    const mesg = JSON.parse(result.data.message);
    if (mesg.status == "Success") {
      //setCallStatus("Dial Now");
    } else {
      setShowElement(true);
      setMessage(mesg.message);
      setTimeout(function () {
        setShowElement(false);
      }, 5000);
    }
  };
  const handleHungUpClick = () => {
    setCallStatus("Hung Up");
  };

  return (
    <>
      <div className="recent-contacts">
        <div className="container">
          {showElement && Message ? (
            <div className="alert alert-warning">{Message}</div>
          ) : (
            <></>
          )}
          <div className="contact_list">
            <div className="row pt-2">
              {contactlist.length > 0 && (
                <>
                  {contactlist.map((contact) => (
                    <>
                      {contact.phones.length > 0 ? (
                        <>
                          {contact.phones.map((phone) => (
                            <>
                              {phone.number.trim().length > 0 ? (
                                <>
                                  <div className="col-12 item" key={phone.id}>
                                    <ContactCard
                                      contactEmail={contact.userPrincipalName}
                                      contactName={contact.displayName}
                                      contactNumber={phone.number}
                                      accountemail={props.accountemail}
                                      onhandleDialClick={handleDialClick}
                                    />
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ))}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <>
        {callStatus === "Dial Now" && (
          <OnCall
            name={dialContactName}
            number={dialContactNumber}
            status={callStatus}
            onhandleHungUpClick={handleHungUpClick}
            accountemail={props.accountemail}
          />
        )}
      </>
    </>
  );
};
export default Recent;
